import { useEffect, useState } from "react";

const tempMessageTimer = null;

export function useTempMessage() {
    const [message, setMessage] = useState("");

    useEffect(() => {
        return () => {
            clearTimeout(tempMessageTimer);
        };
    }, []);

    useEffect(() => {
        clearTimeout(tempMessageTimer);

        if (!message) {
            return;
        }

        setTimeout(() => {
            setMessage("");
        }, 3000);
    }, [message]);

    const trigger = (msg) => {
        setMessage(msg);
    };

    return {
        trigger: trigger,
        message: message,
    };
}
